import { makeStyles } from "@material-ui/core/styles";

const fadeUp = {
  from: {
    opacity: 0,
    transform: "translateY(24px)",
  },
  to: {
    opacity: 1,
    transform: "translateY(0)",
  },
};

const fadeInRight = {
  from: {
    opacity: 0,
    transform: "translateX(40px)",
  },
  to: {
    opacity: 1,
    transform: "translateX(0)",
  },
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "start",
    justifyContent: "space-between",
    maxWidth: "87.5rem",
    margin: "0 auto",
    height: "100%",
    padding: theme.spacing(4),

    animation: "$fadeUp 0.6s ease-out",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
      alignItems: "center",
      padding: theme.spacing(3),
      overflow: "hidden",
    },
  },

  imageCol: {
    flex: 1,
    width: "70%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    animation: "$fadeInRight 0.7s ease-out",
    animationDelay: "0.05s",
    animationFillMode: "both",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: theme.spacing(4),
    },
  },

  image: {
    width: "110%",
    maxWidth: 600,
    height: "auto",
    display: "block",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: 380,
    },
  },

  infoContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    maxWidth: "40%",

    animation: "$fadeUp 0.6s ease-out",
    animationDelay: "0.15s",
    animationFillMode: "both",

    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      textAlign: "center",
      maxWidth: "100%",
    },
  },

  title: {
    fontFamily: "var(--font-family-1)",
    maxWidth: "90vw",
    fontWeight: 500,
    fontSize: 40,
    lineHeight: "56px",

    color: "#C1C9DF",
    marginBottom: theme.spacing(3),

    [theme.breakpoints.down("sm")]: {
      fontSize: 35,
      lineHeight: "36px",
    },
  },

  paragraph: {
    marginBottom: theme.spacing(4),
    maxWidth: 520,
    color: "#C1C9DF",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
    },
  },

  svgAndText: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),

    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },

  svgAndTextSVG: {
    flexShrink: 0,
    width: 24,
    height: 24,
  },

  svgAndTextText: {
    fontFamily: "var(--font-family-3)",
    fontSize: 16,
    lineHeight: "24px",
    color: "#a6b5d9",
  },

  buttonsContainer: {
    display: "flex",
    gap: theme.spacing(2),

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      width: "100%",
      alignItems: "stretch",
    },
  },

  button: {
    minWidth: 170,
    height: 64,
    boxSizing: "border-box",
    fontFamily: "var(--font-family-1)",
    fontWeight: 500,
    fontSize: 18,
    paddingInline: "20px",
    transition: "all 0.4s ease-in-out",
    borderRadius: "32px",

    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
      width: "100%",
      borderRadius: "16px !important",
    },
  },

  requestButton: {
    background: "#f1c157",
    color: "#31343E",
    marginRight: 16,
    borderColor: "#f1c157",
    "&:hover": {
      backgroundColor: "#f4cd79ff",
    },
  },
  moreInfoButton: {
    color: "#fff",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "#fff",
    "&:hover": {
      backgroundColor: "transparent",
      borderColor: "#f1c157",
      color: "#f1c157",
    },
  },

  svgAndText: {
    display: "flex",
    alignItems: "center",
    margin: "10px 0",
  },
  svgAndTextSVG: {
    minWidth: 40,
    minHeight: 40,
    height: 40,
    width: 40,
    marginRight: 15,
  },
  svgAndTextText: {
    fontSize: 18,
    color: "#A6B5D9",
    fontWeight: 500,
    lineHeight: "40px",
    textAlign: "left",
    fontFamily: "var(--font-family-2)",
  },

  "@keyframes fadeUp": fadeUp,
  "@keyframes fadeInRight": fadeInRight,
}));

export default useStyles;
